
import { useState } from "react";

import { Grid, List, ListItem, ListItemText, Typography, Box, Paper, Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider } from "@mui/material"

import moment from "moment"

import { InfoField } from "./InfoField";

import { PromocionProps } from "../interfaces/recepcion/PromocionInterface";
import { DialogDocumento } from "../dialogs/DialogDocumento";
import { DialogContentStyle, DialogActionsStyle } from "../styles/DialogStyle";

interface Props {
    promocion?:    PromocionProps;
}

export const BoxInformacionPromocion = ( { promocion }: Props ) => {
    
    const [openAnexos, setOpenAnexos] = useState( false );
    const [selectedAnexoUrl, setSelectedAnexoUrl] = useState('');
    const [openDocumento, setOpenDocumento] = useState( false );

    const handleCloseAnexos = () => {

        setOpenAnexos( false );
        setSelectedAnexoUrl( '' );

    }

    return (
        <Box p={4} component={ Paper }>

            <Grid container spacing={1}>  
              
                {
                    promocion?.folioBuzonElectronico
                    &&
                        <Grid size={{ md: 6, xs: 12 }}>

                            <InfoField
                                label="Folio buzón electrónico" 
                                value={ promocion?.folioBuzonElectronico }
                                fontSize={ 16 }
                            />     

                        </Grid>
                }  
               
                {
                    promocion?.anexosBuzonElectronico.length !== 0
                    &&
                        <Grid size={{ md: 6, xs: 12 }}>

                            <List disablePadding>

                                <ListItem sx={{ py: 0, px: 0 }}>

                                    <ListItemText
                                        sx={{ mr: 2 }}
                                        primary={ <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Anexo(s) buzón electrónico: </Typography> }
                                        secondary={
                                            <Button
                                                fullWidth
                                                variant='contained'
                                                sx={{ mt: 1 }}
                                                onClick={ () => setOpenAnexos(true) }
                                            >
                                                Anexo(s)
                                            </Button>
                                        }
                                    />

                                </ListItem>

                            </List>

                        </Grid>
                }

                {
                    promocion?.tipoPromocion
                    &&
                        <Grid size={{ md: 6, xs: 12 }}>

                            <InfoField
                                label="Tipo de promoción" 
                                value={ promocion?.tipoPromocion }
                                fontSize={ 16 }
                            />     

                        </Grid>
                }     

                {
                    promocion?.fecha
                    &&
                        <Grid size={{ md: 6, xs: 12 }}>

                            <InfoField
                                label="Fecha" 
                                value={ moment( new Date( promocion?.fecha ) ).format( 'DD-MM-YYYY' ) }
                                fontSize={ 16 }
                            />  
                            
                        </Grid>    
                }                

                {
                    promocion?.digitalizacion
                    &&
                        <Grid size={{ md: 12, xs: 12 }}>

                            <List disablePadding>
                
                                <ListItem sx={{ py: 0, px: 0 }}>

                                    <ListItemText
                                        sx={{ mr: 2 }}
                                        primary={ 
                                            <Typography  
                                                variant="subtitle2"
                                                sx={{
                                                    color: "text.secondary",
                                                    letterSpacing: 0.5,
                                                    fontWeight: 700,
                                                }}> 
                                                    Digitalización: 
                                            </Typography> 
                                        }                           
                                    />

                                </ListItem>

                            </List>

                            <iframe 
                                title='iframe-documento'
                                style={{ width: '100%', height: 800, borderRadius: 8 }}
                                src={ promocion?.digitalizacion }
                            />

                        </Grid>                                         
                }
               
                {
                    promocion?.acuseBuzonElectronico
                    &&
                        <Grid size={{ md: 12, xs: 12 }}>

                            <List disablePadding>
                
                                <ListItem sx={{ py: 0, px: 0 }}>

                                    <ListItemText
                                        sx={{ mr: 2 }}
                                        primary={ 
                                            <Typography  
                                                variant="subtitle2"
                                                sx={{
                                                    color: "text.secondary",
                                                    letterSpacing: 0.5,
                                                    fontWeight: 700,
                                                }}> 
                                                    Acuse de envió buzón electronico: 
                                            </Typography> 
                                        }                           
                                    />

                                </ListItem>

                            </List>

                            <iframe 
                                title='iframe-documento'
                                style={{ width: '100%', height: 800, borderRadius: 8 }}
                                src={ promocion?.acuseBuzonElectronico }
                            />

                        </Grid>                                         
                }                

            </Grid>    
            
            <Dialog
                fullWidth
                maxWidth="md"
                open={ openAnexos }
                onClose={ handleCloseAnexos }
            >

                <DialogTitle>
                    Anexo(s) buzón electrónico
                </DialogTitle>

                <DialogContent sx={ DialogContentStyle }>

                    <List disablePadding>

                        {
                            promocion?.anexosBuzonElectronico.map( (anexo, index) => (

                                <Box key={ index }>

                                    <ListItem sx={{ py: 2, px: 0 }}>

                                        <ListItemText
                                            primary={ <Typography variant='subtitle2' fontWeight='bold'>{ anexo.archivo }</Typography> }
                                            slotProps={{ primary: { component: 'div' }, secondary: { component: 'div' } }}
                                        />

                                        <Button
                                            variant='contained'
                                            size='small'
                                            onClick={ () => { setSelectedAnexoUrl( anexo.url ); setOpenDocumento( true ); } }
                                        >
                                            Ver
                                        </Button>

                                    </ListItem>

                                    {
                                        index < ( promocion?.anexosBuzonElectronico.length ?? 0 ) - 1
                                        &&
                                            <Divider />
                                    }

                                </Box>

                            ))
                        }

                    </List>

                </DialogContent>

                <DialogActions sx={ DialogActionsStyle }>

                    <Button color='secondary' onClick={ handleCloseAnexos }>
                        Cerrar
                    </Button>

                </DialogActions>

            </Dialog>

            <DialogDocumento
                documento={ selectedAnexoUrl }
                openDialog={ openDocumento }
                handleCloseDialog={ () => setOpenDocumento( false ) }
            />

        </Box>
    )
}
